import { render, staticRenderFns } from "./comp_CategoriesMegaMenu-Image.vue?vue&type=template&id=7778c28b&scoped=true"
import script from "./comp_CategoriesMegaMenu-Image.vue?vue&type=script&lang=js"
export * from "./comp_CategoriesMegaMenu-Image.vue?vue&type=script&lang=js"
import style0 from "./comp_CategoriesMegaMenu-Image.vue?vue&type=style&index=0&id=7778c28b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7778c28b",
  null
  
)

export default component.exports